/* tslint:disable */
/* eslint-disable */
export enum WorkProjectShareStatusEnum {
  Valid = 'VALID',
  NotYetValid = 'NOT_YET_VALID',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}
